// src/redux/actions/notificationActions.js

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";

/**
 * Charger toutes les notifications (non lues)
 */
export const fetchNotifications = (token) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    return async (dispatch) => {
        try {
            const response = await fetch(`${apiUrl}/api/notifications`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de la récupération des notifications");
            }

            dispatch({
                type: SET_NOTIFICATIONS,
                payload: data.notifications || [],
            });
        } catch (error) {
            console.error("Erreur fetchNotifications :", error);
        }
    };
};


/**
 * Marquer une notification comme lue + recharger la liste
 */
export const readNotification = (token, notifId) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    return async (dispatch) => {
        try {
            const formData = new FormData();
            formData.append("idNotif", notifId);

            const response = await fetch(`${apiUrl}/api/notifications/read`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de la mise à jour de la notification");
            }

            // 🔥 On recharge la liste des NON LUES depuis l’API (source de vérité)
            dispatch(fetchNotifications(token));

        } catch (error) {
            console.error("Erreur readNotification :", error);
        }
    };
};
